// extracted by mini-css-extract-plugin
module.exports = {"ganttChart":"GanttChart_ganttChart__20rKz"};